<template>
  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="publish" color="negative" text-color="white" />
        <span class="q-ml-sm">Do you want to published this record?.</span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="warning" v-close-popup />
        <q-btn flat :loading="isSubmitted" label="Publish" color="positive" @click="confirmPublish" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar' 
import { ref } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"
export default {
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const confirm = ref(false)
    const id = ref(null)
    const total = ref(null)
    const isSubmitted = ref(false)

    EventBus.on("publishedAssessmentModal",(val) => {
        id.value = val.id
        total.value = val.total
        confirm.value = val.status
    })

    const confirmPublish = () => {
      isSubmitted.value = true; 
      axios.post(process.env.VUE_APP_API_URL + '/assessment/published',{"id":id.value.trim(),"items":total.value},{
        headers: { 'Authorization': `Bearer ${token.value}`},
      }).then(() => {
          isSubmitted.value = false
          confirm.value = false
          $q.notify({
            color: 'positive',
            textColor: 'white',
            icon: 'check_circle',
            message: 'Record Published'
          })
          EventBus.emit("refreshAssessment")
        }).catch((e) => {
         isSubmitted.value = false
         confirm.value = false
         $q.notify({
            color: 'negative',
            textColor: 'white',
            icon: 'warning',
            message: e.response.data.message
          })
      })
    }

    return {
      token,
      confirm,
      id,
      total,
      isSubmitted,
      confirmPublish
    }
  }
}
</script>